/** Dönüşüm işinin belge türü (`donusum_isi.belge_turu`). Kütük türü `ndt_sertifika` ve NDT raporu türü `ndt` ile karışmasın diye ayrı ad. */
export const NDT_SERTIFIKA_BELGE_TURU = "ndt_personel";
/** Okunan Documents türü (GELEN_TURLERI anahtarı, "NDT certificate"; Registers grubu, kişisel sınıf). */
export const NDT_SERTIFIKA_GELEN_TURU = "kutuk:ndt_inspektor:ndt_sertifika";
export const ndtSertifikaGelenTuruMu = (t) => t === NDT_SERTIFIKA_GELEN_TURU;
/** Olay kaydında nesne tipi (nesneId = ndt_sertifika_kaydi.id). */
export const NDT_SERTIFIKA_OLAY_NESNESI = "ndt_sertifika_kaydi";
/** Okunan hafif excel'in belge ailesi. Hiçbir aile sorgusu bu adı almaz (Riser Documentation, kanıt zinciri ve aile işlemleri). */
export const NDT_SERTIFIKA_GIRDI_AILESI = "NDT-certificate-input";
/** DOCUMENT sayfasındaki "Document type" değeri. */
export const NDT_SERTIFIKA_EXCEL_ADI = "NDT certificate";
/** Bir sertifikada en çok yöntem satırı (`Row`). */
export const NDT_SERTIFIKA_SATIR_EN_COK = 8;
/** Okuma işi kodu ("NDTC-5A1B2C3D"); "NDT-" uyarı kodlarından ve NDT raporu kodundan ayrı. */
export const ndtSertifikaKodu = (kayitId) => `NDTC-${kayitId.replace(/-/g, "").slice(0, 8).toUpperCase()}`;
/**
 * Sertifika düzeyi alanlar (DOCUMENT; sabit sıra; sözleşme §7.3, sürüm 1). Her alanın tüketicisi sözleşmede yazılıdır. `etiket` hem ekran metni hem
 * DOCUMENT'teki Field adıdır. Kimlik değeri yalnız sertifika no'dur (şüpheliyse kör yazma).
 */
export const NDT_SERTIFIKA_ALANLARI = [
    { alan: "ad", etiket: "Holder name", kimlik: false }, { alan: "sertifika_no", etiket: "Certificate number", kimlik: true },
    { alan: "sema", etiket: "Scheme", kimlik: false }, { alan: "isveren", etiket: "Employer", kimlik: false },
    { alan: "sektorler", etiket: "Sectors", kimlik: false }, { alan: "duzenleme_tarihi", etiket: "Issue date", kimlik: false },
];
/** Yöntem satırı alanları (ROWS, satır başına 4; sabit sıra; sözleşme §7.3, sürüm 1). */
export const NDT_SERTIFIKA_SATIR_ALANLARI = [
    { alan: "yontem", etiket: "Method", kimlik: false }, { alan: "seviye", etiket: "Level", kimlik: false },
    { alan: "baslangic", etiket: "Valid from", kimlik: false }, { alan: "bitis", etiket: "Valid until", kimlik: false },
];
/** Alanın ekran adı (iki listede aranır); bilinmiyorsa alanın kendisi. */
export const ndtSertifikaEtiketi = (alan) => [...NDT_SERTIFIKA_ALANLARI, ...NDT_SERTIFIKA_SATIR_ALANLARI].find((a) => a.alan === alan)?.etiket ?? alan;
/** ROWS başlığı (uzun biçim: her hücre bir satır). */
export const NDT_SERTIFIKA_SATIR_BASLIKLARI = ["Row", "Field", "Value", "As written", "Page", "Certainty"];
/** Kişinin "Add to Registers" onayının alanı (`belge_deger_onayi.alan`; parça 1, satır başına bir kez). */
export const YONTEM_SATIRI_ALANI = (sira) => `yontem_satiri:${sira}`;
/* ---------------- değer biçimleri (yalnız kesin değerler kullanılır) ---------------- */
/**
 * Sertifikadaki yöntem yazısı → OASIS yöntemi: büyük harf, boşluk ve noktalama atılır. MT, MPI, MPT, "Magnetic …" → MT; PT, DPI, LPT, LP,
 * "Penetrant …" → PT; UT, "Ultrasonic …" → UT; RT, "Radiograph…" → RT; VT, "Visual …" → VT. Öteki yöntemler (ET, LT …) ve boş değer null.
 */
export function ndtYontemOku(v) {
    const s = (v ?? "").toUpperCase().replace(/[\s\-_.()/]/g, "");
    if (!s)
        return null;
    if (["MT", "MPI", "MPT"].includes(s) || s.startsWith("MAGNETIC"))
        return "MT";
    if (["PT", "DPI", "LPT", "LP"].includes(s) || s.startsWith("PENETRANT") || s.startsWith("LIQUIDPENETRANT") || s.startsWith("DYEPENETRANT"))
        return "PT";
    if (s === "UT" || s.startsWith("ULTRASONIC"))
        return "UT";
    if (s === "RT" || s.startsWith("RADIOGRAPH"))
        return "RT";
    if (s === "VT" || s.startsWith("VISUAL"))
        return "VT";
    return null;
}
/** Basılı seviye: 1/2/3 ya da I/II/III ("Level 2" de okunur); okunamazsa null. NDT raporu karşılaştırmasının `seviyeOku`'su budur. */
export function ndtSeviyeOku(x) {
    const m = /(?:^|\b|level\s*)(III|II|I|[123])\b/i.exec((x ?? "").trim());
    if (!m)
        return null;
    const v = m[1].toUpperCase();
    return v === "III" || v === "3" ? 3 : v === "II" || v === "2" ? 2 : 1;
}
/** Sertifikanın şeması: ISO 9712 (EN 473 dahil) · SNT-TC-1A (işverene bağlı) · başka; boşsa null. */
export function ndtSemaOku(v) {
    const s = (v ?? "").trim();
    if (!s)
        return null;
    if (/SNT[\s-]*TC[\s-]*1A/i.test(s))
        return "snt";
    if (/(EN\s*)?ISO\s*9712|EN\s*473/i.test(s))
        return "iso9712";
    return "diger";
}
/** Kaynakları ve boruları kapsayan sektör yazımları (ISO 9712 ürün sektörleri w, t; endüstri sektörü "Manufacturing", "pre- and in-service"). */
const SEKTOR_KAPSAR = new Set(["w", "t", "weld", "welds", "welded", "welding", "tube", "tubes", "pipe", "pipes", "tubular", "manufacturing", "ms", "multi-sector"]);
/** Kaynakları ve boruları kapsamayan sektör yazımları (döküm, dövme, haddeleme, kompozit, demiryolu, havacılık). */
const SEKTOR_KAPSAMAZ = new Set(["c", "f", "wp", "cm", "casting", "castings", "forging", "forgings", "wrought", "composite", "composites", "railway", "aerospace"]);
/** Bağlaçlar parça sayılmaz. */
const BAGLACLAR = new Set(["and", "&", "ve"]);
/**
 * NDT-08'in kapsam kararı (muhafazakâr): bir parça kapsayan kümedeyse "kapsar"; bütün parçalar kapsamayan kümedeyse "kapsamaz"; öteki her yazım
 * "bilinmiyor" (uyarı değil, not). Tanınmayan yazımda yanlış alarm verilmez.
 */
export function ndtSektorKapsami(v) {
    const parcalar = (v ?? "").toLowerCase().split(/[,;/\n]|\s+/).map((x) => x.trim()).filter((x) => x && !BAGLACLAR.has(x));
    if (!parcalar.length)
        return "bilinmiyor";
    if (parcalar.some((x) => SEKTOR_KAPSAR.has(x) || x.includes("pre-") || x.includes("in-service")))
        return "kapsar";
    if (parcalar.every((x) => SEKTOR_KAPSAMAZ.has(x)))
        return "kapsamaz";
    return "bilinmiyor";
}
/** GEN-17: yazıldığı gibi değer sayısal gg/aa/yyyy biçiminde ve iki sayı da 12 ya da küçük ve farklıysa gün ve ay sırası belirsizdir. */
export function gunAyBelirsiz(yazildigi) {
    const m = /^(\d{1,2})[./-](\d{1,2})[./-](\d{2}|\d{4})$/.exec((yazildigi ?? "").trim());
    if (!m)
        return false;
    const a = Number(m[1]);
    const b = Number(m[2]);
    return a >= 1 && b >= 1 && a <= 12 && b <= 12 && a !== b;
}
/* ---------------- uyarılar ---------------- */
/** Üretilen kodlar (üretim sırası: kırmızı, sarı, gri). Hiçbiri KAPALI_UYARI_KODLARI'nda olamaz (test). GEN-02, GEN-09, GEN-14, GEN-19 yoktur. */
export const NDT_SERTIFIKA_UYARI_KODLARI = ["NDT-09", "GEN-17", "NDT-07", "NDT-08"];
/** Uyarı kalıpları (İngilizce anahtar; Türkçesi sözlükte). */
export const NDT_SERTIFIKA_UYARI_KALIPLARI = {
    "NDT-09": "Name differs from the register: {0} / {1}.",
    "GEN-17": "Day and month order unclear: {0}.",
    "NDT-07": "Certificate tied to employer {0}.",
    "NDT-08": "Sector does not cover welds or tubes.",
};
//# sourceMappingURL=ndt-sertifika.js.map